import { DeleteFilled, EditFilled } from '@ant-design/icons/lib/icons';
import { Badge, Button, message, Popconfirm, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteDataTrouser, getDataTrouser } from '../../../config/Redux/action';

const DashboardTrouser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [trousers, setTrousers] = useState([]);
  const loading = useSelector((state) => state.product.isLoading);
  
  useEffect(() => {
    const getData = async () => {
      const res = await dispatch(getDataTrouser());
      setTrousers(res.map((trouser, index) => {
        return{
          key: index,
          no: index + 1,
          id: trouser.id,
          name: trouser.data.name,
          kind: trouser.data.kind,
          stock: trouser.data.stock,
          price: trouser.data.price,
          promoPrice: trouser.data.promoPrice,
          shopee: trouser.data.shopee,
          tokopedia: trouser.data.tokopedia,
          lazada: trouser.data.lazada,
          image_url: trouser.data.image_url,
          desc: trouser.data.desc,
          size: trouser.data.size,
          publish: trouser.data.publish,
          benefit: trouser.data.benefit
        }
      }));
    };

    getData();
  },[dispatch])

  const handleEdit = (e) => {
    const id = e.currentTarget.value;
    navigate(`/dashboard/trouser/edit/${id}`);
  }

  const handleDelete = (id) => {
    dispatch(deleteDataTrouser(id));
    const newData = trousers.filter((trouser) => trouser.id !== id);
    setTrousers(newData);
  }

  const dataSource = trousers;

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      align: 'center',
      width: '2%',
    },
    {
      title: 'image',
      dataIndex: 'image_url',
      key: 'image_url',
      align: 'center',
      width: '15%',
      render: (res) => {
        return <img src={res} alt='gambar' width={150} height={150} />;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: '15%',
    },
    {
      title: 'Kinds',
      dataIndex: 'kind',
      key: 'kind',
      align: 'center',
      width: '12%',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      align: 'center',
      width: '10%',
      render: (res) => {
        const price = parseInt(res);
        return <span>{`Rp. ${price.toLocaleString(`id-ID`)}`}</span>;
      },
    },
    {
      title: 'Promo Price',
      dataIndex: 'promoPrice',
      key: 'promoPrice',
      align: 'center',
      width: '10%',
      render: (res) => {
        const price = parseInt(res);
        return <span>{`Rp. ${price.toLocaleString(`id-ID`)}`}</span>;
      },
    },
    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
      align: 'center',
      width: '5%',
    },
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      align: 'center',
      width: '12%',
      render: (res) => {
        let data = [];
        // eslint-disable-next-line array-callback-return
        Object.keys(res).map((key) => {
          data.push({
            size: key,
            val: res[key],
          });
        });
        const size = data
          .filter((res, index) => res.val === true)
          .map((res, index) => {
            return (
              <Badge
                key={index}
                status='success'
                text={<span style={{ marginLeft: '-4px' }}>{res.size}</span>}
                style={{ paddingRight: '10px' }}
              />
            );
          });
        return size;
      },
    },
    {
      title: 'Published',
      dataIndex: 'publish',
      key: 'publish',
      align: 'center',
      width: '5%',
      render: (res) => {
        return res === 'published' ? 'Yes' : 'No';
      },
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      width: '14%',
      render: (result) => {
        return (
          <>
            <Button
              value={result.id}
              icon={<EditFilled />}
              style={{ display: 'inline-block' }}
              onClick={handleEdit}
            />
            <Popconfirm
              onConfirm={() => handleDelete(result.id)}
              title={'Do You Want To Delete Data?'}
              onCancel={() => message.error('Data is Not Deleted')}
            >
              <Button
                icon={<DeleteFilled />}
                danger
                type='primary'
                style={{ display: 'inline-block', marginLeft: '12px' }}
              />
            </Popconfirm>
          </>
        );
      },
    },
  ];
    return (
      <Table dataSource={dataSource} columns={columns} loading={loading} />
    );
}

export default DashboardTrouser
